// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//


import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import {
    getCategoryState
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadCategory from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategory";
import { getLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import React from "react";
import { useDispatch } from "react-redux";

export const useGetLinks = <T>(list: T[], linkSelector: (item: T) => LinkFieldValue) => {
    const linkFields = list.map(linkSelector);

    const links = useAppSelector(state =>
        linkFields.map(o => {
            const link = getLink(state, o);
            return !link ? { url: undefined, title: undefined } : link;
        }),
    );

    const categoryStates = useAppSelector(state =>
        linkFields.map(linkField => {
            if (linkField.type !== "Category") {
                return;
            }

            return getCategoryState(state, linkField.value);
        }),
    );

    const dispatch = useDispatch();

    React.useEffect(() => {

        for (let x = 0; x < links.length; x++) {
            const linkField = linkFields[x];
            const link = links[x];
            const categoryState = categoryStates[x];

            if (
                linkField.type === "Category" &&
                linkField.value &&
                !link.url &&
                !categoryState?.isLoading &&
                !categoryState?.errorStatusCode
            ) {
                dispatch(loadCategory({ id: linkField.value }));
            }
        }
    }, [links, categoryStates, linkFields, dispatch]);

    return links;
};